window.ProductQuiz = {
  ...window.ProductQuiz,
  QUIZ_KEY: "productQuiz",
  RESULTS_KEY: "prq_results",
  MAX_TIMESTAMPS: 5,
  debug: window.location.hostname.match(/local|dev|qa/) ? true : false,
  renderLoggedInAttempts: 0,
  modals: {
    register: document.getElementById("PopupModal-quiz-save-results-register"),
    login: document.getElementById("PopupModal-quiz-save-results-login"),
    loggedIn: document.getElementById("PopupModal-quiz-save-results-loggedin"),
  },

  getSiteRegion: () => {
    let region = window.Shopify?.theme?.name?.match(
      /[-\/](anz|ca|eu|uk|us)\//,
    )?.[1]
    if (!region) {
      region = location.hostname?.match(/-(anz|ca|eu|uk|us)[-.]/)?.[1]
    }
    return region || "us"
  },

  getAccountData: async () => {
    try {
      const response = await fetch("/?section_id=account-recommendations", {
        method: "GET",
      })
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`)
      }
      const htmlString = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(htmlString, "text/html")
      const element = doc.getElementById("customer-quiz-results")
      if (element) {
        const recommendations = JSON.parse(element.textContent)
        if (ProductQuiz.debug) {
          console.log("fetched account recommendations", recommendations)
        }
        return recommendations
      }
      return null
    } catch (error) {
      console.error("Fetch error:", error)
      return null
    }
  },

  setQuizEndTime: () => {
    const quizData =
      JSON.parse(localStorage.getItem(ProductQuiz.QUIZ_KEY)) || {}
    const answers = JSON.parse(
      localStorage.getItem(ProductQuiz.RESULTS_KEY),
    )?.answers
    if (answers) {
      // add quiz completion timestamp
      if (!Array.isArray(quizData.endTimes)) {
        quizData.endTimes = []
      }
      const currentTimestamp = Date.now()
      quizData.endTimes.push(currentTimestamp)
      if (quizData.endTimes.length > ProductQuiz.MAX_TIMESTAMPS) {
        quizData.endTimes.shift()
      }
      if (ProductQuiz.debug) {
        console.log("quiz end time", new Date(currentTimestamp).toISOString())
      }
      localStorage.setItem(ProductQuiz.QUIZ_KEY, JSON.stringify(quizData))
    }
  },

  parseResults: () => {
    const quizData = {}
    const answers = JSON.parse(
      localStorage.getItem(ProductQuiz.RESULTS_KEY),
    )?.answers

    // Check if the data exists and is a valid JSON object
    if (answers) {
      try {
        const resultType = answers[0].entries.filter(
          (a) => a.type === "custom",
        )[0].value

        quizData[resultType] = {
          gift: resultType === "someone_else",
          need: answers[1].entries[0].value,
          products: ProductQuiz.products,
        }
        if (answers.length > 3) {
          quizData[resultType].targets = answers[2].entries
            .filter((a) => a.type === "custom" && !a.src.endsWith("button1"))[0]
            .value.split(",")
          quizData[resultType].features = answers[3].entries
            .filter((a) => a.type === "custom" && !a.src.endsWith("button1"))[0]
            .value.split(",")
        } else {
          quizData[resultType].targets = []
          quizData[resultType].features = answers[2].entries
            .filter((a) => a.type === "custom" && !a.src.endsWith("button1"))[0]
            .value.split(",")
        }
      } catch (e) {
        console.warn("corrupted data", { quizData, answers }, e)
      }
    } else {
      throw new Error("missing answers")
    }
    if (ProductQuiz.debug) {
      console.log("parsed quiz results", quizData)
    }
    return quizData
  }, // end parseResults

  retakeButtonHandler: () => {
    dataLayer.push({
      event: "quiz_result_retake",
      page_location: window.location.href,
    })
    localStorage.removeItem(ProductQuiz.RESULTS_KEY)
    setTimeout(function () {
      window.location.href = "/pages/quiz"
    }, 100)
  },

  saveResults: async (accountData, quizData) => {
    // disable save button
    const saveButton = document.querySelector("button.save-results")
    if (saveButton) {
      saveButton.disabled = true
      saveButton.classList.add("disabled")
    }
    try {
      const result = quizData.myself || quizData.someone_else
      if (!accountData) throw new Error("customer data not available")
      if (!result) throw new Error("no results to save")

      const payload = {
        event: "product-recommendations",
        region: ProductQuiz.getSiteRegion(),
        customerId: accountData.customer_id, // this is the shopify customer id (not the cognito sub)
        customerIdHash: accountData.customer_id_hash, // this is a hash of the shopify customer id from the shopify backend
        isGift: !!result.gift,
        needText: result.need,
        targetAreas: result.targets,
        featureList: result.features,
        productIds: result.products.map((p) => p.id),
      }
      if (ProductQuiz.debug) {
        console.log("save quiz results", payload)
      }
      const response = await fetch("/apps/custom-events", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`)
      } else {
        // set savedAt timestamp in localStorage
        const localQuizData =
          JSON.parse(localStorage.getItem(ProductQuiz.QUIZ_KEY)) || {}
        if (payload.isGift === true) {
          $("a.go-to-account").attr("href", "/account#personalization-gift")
        }
        if (quizData.myself) {
          quizData.myself.savedAt = new Date().getTime()
        } else if (quizData.someone_else) {
          quizData.someone_else.savedAt = new Date().getTime()
        }
        const savedQuizData = { ...localQuizData, ...quizData }
        localStorage.setItem(
          ProductQuiz.QUIZ_KEY,
          JSON.stringify(savedQuizData),
        )

        dataLayer.push({
          event: "quiz_result_save",
          page_location: window.location.href,
          mobile_app: !!Shopify?.Therabody?.MobileApp?.isMobileApp,
        })

        if (saveButton) {
          // update save button text
          saveButton.innerText = saveButton.getAttribute("data-saved")
        }
      }
    } catch (e) {
      if (saveButton) {
        // enable save button
        saveButton.disabled = false
        saveButton.classList.remove("disabled")
      }
      // set failedAt timestamp in localStorage
      const localQuizData =
        JSON.parse(localStorage.getItem(ProductQuiz.QUIZ_KEY)) || {}
      if (quizData.myself) {
        quizData.myself.failedAt = new Date().toISOString()
      } else if (quizData.someone_else) {
        quizData.someone_else.failedAt = new Date().toISOString()
      }
      const savedQuizData = { ...localQuizData, ...quizData }
      localStorage.setItem(ProductQuiz.QUIZ_KEY, JSON.stringify(savedQuizData))

      console.error("error saving quiz results", e)
      return false
    }
    return true
  },

  saveButtonHandler: async () => {
    const accountData = await ProductQuiz.getAccountData()
    if (accountData?.customer_id) {
      document.getElementById("PopupModal-quiz-save-results-loggedin").show()
    } else {
      // document.getElementById("PopupModal-quiz-save-results-login").show()
      document.getElementById("PopupModal-quiz-save-results-register").show()
    }
  },

  renderLoggedInModal: async () => {
    const quizData = ProductQuiz.parseResults()
    const accountData = await ProductQuiz.getAccountData()
    if (!accountData?.customer_id || !quizData) {
      renderLoggedInAttempts++
      if (renderLoggedInAttempts < 5) {
        setTimeout(() => {
          ProductQuiz.renderLoggedInModal()
        }, 250)
        console.warn("missing quiz data or account data available", {
          quizData,
          accountData,
        })
        return
      } else {
        console.error("failed to get quiz data or account data", {
          quizData,
          accountData,
        })
      }
    }
    let overwrite =
      (quizData?.myself && accountData?.recommendations?.myself) ||
      (quizData?.someone_else && accountData?.recommendations?.someone_else) ||
      false
    const elOverwrite =
      ProductQuiz.modals.loggedIn.querySelector(".overwrite-result")
    const elSaveSuccess =
      ProductQuiz.modals.loggedIn.querySelector(".save-success")
    if (ProductQuiz.debug) {
      console.log("quiz save results logged in. Overwrite?", overwrite)
    }
    if (overwrite) {
      elOverwrite.style.display = "block"
      if (!ProductQuiz.isHandlerOverwrite) {
        // wire up confirm button
        ProductQuiz.modals.loggedIn
          .querySelector("button.confirm-overwrite-result")
          .addEventListener("click", () => {
            if (ProductQuiz.debug) {
              console.log("Overwrite clicked")
            }
            ProductQuiz.saveResults(accountData, quizData)
            elSaveSuccess.style.display = "block"
            elOverwrite.style.display = "none"
          })
        ProductQuiz.isHandlerOverwrite = true
      }
    } else {
      ProductQuiz.saveResults(accountData, quizData)
      elSaveSuccess.style.display = "block"
    }
  },

  updateAnswersContent: async () => {
    // update quiz answers labels
    // quizData needs to load from the customer's data if the querystring has type=gift or type=personal
    const typeQuery = new URLSearchParams(window.location.search)?.get("type")
    let isGift = typeQuery === "gift"
    let isPersonal = typeQuery === "personal"
    let answers = null

    if (isGift || isPersonal) {
      const accountData = await ProductQuiz.getAccountData()
      const quizData = accountData?.recommendations
      answers = isGift ? quizData?.someone_else : quizData?.myself
    } else {
      const quizData = ProductQuiz.parseResults()
      isGift = !!quizData?.someone_else
      isPersonal = !!quizData?.myself
      answers = quizData?.myself || quizData?.someone_else
    }

    if (answers) {
      const quizAnswersNeedLabel = document.getElementById(
        "quiz-answers-need-label",
      )
      const quizAnswersGiftNeedLabel = document.getElementById(
        "quiz-answers-gift-need-label",
      )
      const quizAnswersNeed = document.getElementById("quiz-answers-need")
      const quizAnswersTargets = document.getElementById("quiz-answers-targets")
      const quizAnswersFeatures = document.getElementById(
        "quiz-answers-features",
      )
      if (isPersonal) {
        quizAnswersNeedLabel.style.display = "block"
      } else if (isGift) {
        quizAnswersGiftNeedLabel.style.display = "block"
      }
      quizAnswersNeed.textContent = answers?.need
      if (answers.targets) {
        for (const target of answers.targets) {
          const li = document.createElement("li")
          li.textContent = target
          quizAnswersTargets.appendChild(li)
        }
        if (answers.targets?.length > 0) {
          const quizAnswersTargetsWrapper = document.getElementById(
            "quiz-answers-targets-wrapper",
          )
          quizAnswersTargetsWrapper.style.display = "flex"
        }
      }
      if (answers.features) {
        for (const feature of answers.features) {
          const li = document.createElement("li")
          li.textContent = feature
          quizAnswersFeatures.appendChild(li)
        }
      }
    } else {
      console.warn("missing answers", { answers, isGift, isPersonal })
      const quizAnswers = document
        .getElementsByClassName("quiz-answers")
        ?.item(0)
      if (quizAnswers) {
        quizAnswers.style.display = "none"
      }
    }
  },

  mobileAppInit: async () => {
    // auto-save if landing here after completing the quiz
    const params = new URLSearchParams(window.location.search)
    const resultType = params.get("type") || ""
    if (resultType !== "personal" && resultType !== "gift") {
      // initial results scenario (type not set to load existing results)
      const quizData = ProductQuiz.parseResults()
      const accountData = await ProductQuiz.getAccountData()
      if (accountData?.customer_id) {
        const saved = await ProductQuiz.saveResults(accountData, quizData)
        if (saved) {
          const MobileApp = Shopify.Therabody.MobileApp
          const result = quizData.myself || quizData.someone_else
          MobileApp.Event.dispatch(MobileApp.Events.QUIZ_SAVED, {
            params: {
              quizData: JSON.stringify(result),
            },
          })
        }
      } else {
        console.warn("missing account data", { accountData, quizData })
      }
    }
  },

  generateFakeResults: async () => {
    if (!ProductQuiz.debug) {
      return false
    }
    const accountData = await ProductQuiz.getAccountData()
    if (!accountData?.customer_id) {
      console.error("You must be logged in to generate fake results")
      return false
    }
    const params = new URLSearchParams(window.location.search)
    const type = params.get("type")
    const isGift = type === "gift"
    const resultKey = isGift ? "someone_else" : "myself"

    const quizData = {
      [resultKey]: {
        gift: isGift,
        need: "Recovery after workouts",
        targets: ["Back", "Legs", "Shoulders"],
        features: ["Heat", "Quiet", "Portable"],
        products: ProductQuiz.products,
      },
    }
    console.log("generating fake quiz results", { resultKey, quizData })
    const saved = await ProductQuiz.saveResults(accountData, quizData)
    console.log(saved ? "fake results saved" : "fake results failed to save")
    return saved
  },

  init: async () => {
    const typeQuery = new URLSearchParams(window.location.search)?.get("type")
    const isRevisit = /^(gift|personal)$/.test(typeQuery)
    if (!isRevisit) {
      ProductQuiz.setQuizEndTime()
      const localQuizData =
        JSON.parse(localStorage.getItem(ProductQuiz.QUIZ_KEY)) || {}
      const quizData = { ...localQuizData, ...ProductQuiz.parseResults() }
      localStorage.setItem(ProductQuiz.QUIZ_KEY, JSON.stringify(quizData))
    }

    // wire up retake and save buttons
    ;(($) => {
      $(document).ready(function () {
        $(".quiz-buttons").on("click", "button.retake-quiz", (event) => {
          event.preventDefault()
          ProductQuiz.retakeButtonHandler()
        })
        $(".quiz-buttons").on("click", "button.save-results", (event) => {
          event.preventDefault()
          ProductQuiz.saveButtonHandler()
        })
        // fix cta height if promotional message is present
        if ($(".quiz-result-hero .coupon-bottom-text").length > 0) {
          $(".quiz-result-hero .cta").addClass("has-promotional-message")
          $("footer.footer").addClass("has-promotional-message")
        }
      })
    })(jQuery)

    // update register modal with quiz details
    ProductQuiz.modals.register?.addEventListener(
      "modal:open",
      async (event) => {
        ;(($) => {
          $(".customer.register h1").after(
            $("#quizRegisterDetails", ProductQuiz.modals.register).remove(),
          )
        })(jQuery)
      },
    )

    // update login modal with quiz details
    ProductQuiz.modals.login?.addEventListener("modal:open", async (event) => {
      ;(($) => {
        $(".customer.login h1#login")
          .next("div")
          .prepend($("#quizLoginDetails", ProductQuiz.modals.login).remove())
        if ($("#quizLoginTitle", ProductQuiz.modals.login).length > 0) {
          $(".customer.login h1#login").text(
            $("#quizLoginTitle", ProductQuiz.modals.login).text(),
          )
          $("#quizLoginTitle", ProductQuiz.modals.login).remove()
        }
      })(jQuery)
    })

    // render logged in modal
    ProductQuiz.modals.loggedIn?.addEventListener(
      "modal:open",
      async (event) => {
        ProductQuiz.renderLoggedInModal()
      },
    )
    if (ProductQuiz.debug) {
      console.log("ProductQuiz initialized")
    }

    if (Shopify?.Therabody?.MobileApp?.isMobileApp) {
      ProductQuiz.mobileAppInit()
      ProductQuiz.updateAnswersContent()
    }
  },
}
ProductQuiz.init()
